var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 399,
    height: 299,
    x: 0.5,
    y: 0.5,
    fill: "#D8E1E3",
    stroke: "#878F93",
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130 90)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 120,
    fill: "#FFF",
    fillOpacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "#93ACC8",
    rx: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "14.299 72 79.949 72 60.957 44.745 49 59.702 34.836 34.246"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 29,
    r: 8,
    fill: "#FFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/default-image.ee46007f449b143090a007703e955cb4.svg";
export { ForwardRef as ReactComponent };